import { networkClient } from './client';
import type { ApiEnvelope, TeamPageMatchdayStatus } from './types';

export interface BECurrentMatchday {
  id: string;
  name: string;
  number: number;
  status: TeamPageMatchdayStatus;
  startsAt: string | null;
  locksAt: string | null;
  budgetInitial: number;
  maxTransfers: number;
}

export interface BECurrentGameweek {
  id: string;
  name: string;
  number: number;
  status: string;
  startsAt: string | null;
  locksAt: string | null;
  budgetInitial: number;
  maxTransfers: number;
}

export interface BECurrentMatchdayWindow {
  currentMatchday: BECurrentMatchday | null;
  nextMatchday: BECurrentMatchday | null;
  currentGameweek: BECurrentGameweek | null;
  nextGameweek: BECurrentGameweek | null;
  // Only returned by /api/teams/current-matchday-window (fetchTeamCurrentMatchdayWindow),
  // not the shared /api/matchdays/current endpoint - optional so callers of either must
  // handle its absence explicitly rather than assume it's always present.
  isOnboardingWindow?: boolean;
}

export interface GetCurrentMatchdayParams {
  tournamentCalendarId: string;
  userId?: string;
  format?: 'classic_season_long' | 'knockout';
}

export type CurrentMatchdayResponse = ApiEnvelope<BECurrentMatchdayWindow>;

export const fetchCurrentMatchday = (
  params: GetCurrentMatchdayParams
): Promise<CurrentMatchdayResponse> => {
  return networkClient
    .get<CurrentMatchdayResponse>('/api/matchdays/current', { params })
    .then(({ data }) => data);
};

export const fetchTeamCurrentMatchdayWindow = (
  params: GetCurrentMatchdayParams
): Promise<CurrentMatchdayResponse> => {
  return networkClient
    .get<CurrentMatchdayResponse>('/api/teams/current-matchday-window', { params })
    .then(({ data }) => data);
};

export interface BEMatchday {
  id: string;
  tournamentCalendarId: string | null;
  matchdayNumber: number;
  name: string;
  expectedMatchCount: number;
  assignedMatches: number;
  status: TeamPageMatchdayStatus;
  startsAt: string | null;
  endsAt: string | null;
  locksAt: string | null;
  budgetInitial: number | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface MatchdaysResponseData {
  matchdays: BEMatchday[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export type MatchdaysResponse = ApiEnvelope<MatchdaysResponseData>;

export interface FetchMatchdaysParams {
  tournamentCalendarId?: string;
  page?: number;
  limit?: number;
  status?: string;
}

export const fetchMatchdays = (params?: FetchMatchdaysParams): Promise<MatchdaysResponse> => {
  return networkClient
    .get<MatchdaysResponse>('/api/matchdays', { params })
    .then(({ data }) => data);
};
